"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reduxForm = require("redux-form");

var _paymentSettingsFormValidation = require("../../utils/paymentSettingsFormValidation");

var _addressFormValidation = require("../../utils/addressFormValidation");

var _recompose = require("recompose");

var _paymentErrorMessage = require("../../utils/paymentErrorMessage");

var _paymentErrorMessage2 = _interopRequireDefault(_paymentErrorMessage);

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _Radio = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Radio");

var _Radio2 = _interopRequireDefault(_Radio);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _PaymentLogos = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/PaymentLogos");

var _PaymentLogos2 = _interopRequireDefault(_PaymentLogos);

var _CreditCardFormFields = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/CreditCardFormFields");

var _CreditCardFormFields2 = _interopRequireDefault(_CreditCardFormFields);

var _PayPalPaymentBox = require("../PaymentForm/component/PayPalPaymentBox");

var _PayPalPaymentBox2 = _interopRequireDefault(_PayPalPaymentBox);

var _PaymentFormSection = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/PaymentFormSection");

var _PaymentFormSection2 = _interopRequireDefault(_PaymentFormSection);

var _euCountries = require("@quixeltools/quixel-ui-library/dist/utils/euCountries");

var _euCountries2 = _interopRequireDefault(_euCountries);

var _AddressFormFields = require("../PaymentForm/component/AddressFormFields");

var _AddressFormFields2 = _interopRequireDefault(_AddressFormFields);

var _SubmitArtPopup = require("@quixeltools/quixel-ui-library/dist/components/common/gallery/SubmitArtPopup");

var _countryStateCodes = require("../../utils/countryStateCodes");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _AddressSettingsForm = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/AddressSettingsForm");

var _AddressSettingsForm2 = _interopRequireDefault(_AddressSettingsForm);

var _PaymentForm = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/PaymentForm");

var _PaymentForm2 = _interopRequireDefault(_PaymentForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEUCountry = _ramda2.default.contains(_ramda2.default.__, _euCountries2.default);

var paymentMethodChoiceRadioButtons = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

var radioLabel = (0, _glamor.css)({
  color: _css.colors.gray,
  marginLeft: (0, _css.unitRem)(3),

  "& .text": {
    display: "inline-block",
    verticalAlign: "middle",

    marginLeft: (0, _css.unitRem)(0.5)
  },

  "&:first-child": {
    marginLeft: 0
  }
});

var radio = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle"
});

var paymentFormFields = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

var footer = (0, _glamor.css)(_css.clearfix, {
  marginTop: (0, _css.unitRem)(1.5)
});

var confirmButton = (0, _glamor.css)({
  float: "right"
});
var link = (0, _glamor.css)({
  display: "block",
  fontSize: "0.9375rem",
  fontWeight: "700",
  width: "100%",
  textAlign: "left",
  lineHeight: "2px",
  padding: (0, _css.unitRem)(0.25) + " " + (0, _css.unitRem)(0.125),
  paddingLeft: 0,
  position: "absolute",
  bottom: "7px",
  letterSpacing: "-0.5px",
  color: "#808080",
  cursor: "pointer",
  transition: "box-shadow " + _css.time.fast + ", color " + _css.time.fast + " ease-in-out",

  "&:hover": {
    color: "white",
    transition: "box-shadow " + _css.time.fast + ", color " + _css.time.fast + " ease-in-out"
  },
  "& *": {
    paddingLeft: 0,
    textDecoration: "none"
  }
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  fontSize: "1.125rem"
}));
var addressFormFields = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

/* eslint-disable jsx-a11y/label-has-for */
var AddressAndPaymentSettingForum = function AddressAndPaymentSettingForum(props) {
  var _props$address = props.address,
      stateList = _props$address.stateList,
      loaded = _props$address.loaded,
      error = _props$address.error,
      loading = _props$address.loading;


  var cities = [];
  var states = [];

  if (stateList) {
    states = stateList.map(function (state) {
      return {
        name: state.name,
        value: state.name,
        code: state.code
      };
    });
    if (props.fields.state.value) {
      var list = stateList.find(function (state) {
        return state.name === props.fields.state.value;
      });
      if (list && list.cities) {
        cities = list.cities.map(function (city) {
          return {
            name: city,
            value: city
          };
        });
      }
    }
  }
  return _react2.default.createElement(
    _Form2.default,
    {
      id: props.fields.paymentMethod.value === "cc" ? "creditCardForm" : "paypalForm",
      className: _SubmitArtPopup.popup,
      onSubmit: props.handleSubmit,
      error: props.error,
      message: props.message
    },
    _react2.default.createElement(
      _PaymentFormSection2.default,
      { title: "Billing Details", hideRule: true },
      _react2.default.createElement(
        "div",
        { className: addressFormFields },
        _react2.default.createElement(_AddressFormFields2.default, {
          fields: props.fields,
          lockCountryAndVat: props.lockCountryAndVat,
          validatingVat: props.validatingVat,
          stateList: props.fields.country.value === "IN" ? (0, _countryStateCodes.getIndiaStates)() : states,
          citiesList: states && cities,
          loaded: !loading && !error,
          onChangeCountryHandler: function onChangeCountryHandler() {
            if (props.fields.country.value === "US" || props.fields.country.value === "CA") {
              props.validatePostalCode({
                countryCode: "",
                postalCode: ""
              });
            }
          }
        })
      )
    ),
    _react2.default.createElement(
      _PaymentFormSection2.default,
      {
        title: "Payment Settings",
        existingMethod: props.existingMethod,
        hideRule: true,
        nextCharge: props.nextCharge
      },
      _react2.default.createElement(
        "div",
        { className: paymentMethodChoiceRadioButtons },
        _react2.default.createElement(
          "label",
          { className: radioLabel },
          _react2.default.createElement(_Radio2.default, (0, _extends3.default)({
            disabled: props.updating,
            className: radio
          }, props.fields.paymentMethod, {
            value: "cc",
            label: "Credit Card",
            checked: props.fields.paymentMethod.value === "cc"
          }))
        ),
        _react2.default.createElement(
          "label",
          { className: radioLabel },
          _react2.default.createElement(_Radio2.default, (0, _extends3.default)({
            disabled: props.updating,
            className: radio
          }, props.fields.paymentMethod, {
            value: "paypal",
            label: "PayPal",
            checked: props.fields.paymentMethod.value === "paypal"
          }))
        )
      ),
      _react2.default.createElement(
        "div",
        { className: paymentFormFields },
        props.fields.paymentMethod.value === "cc" && _react2.default.createElement(_CreditCardFormFields2.default, {
          creditCardPrepare: props.creditCardPrepare,
          error: props.paypalPaymentBoxError,
          disabled: props.updating,
          fields: props.fields
        }),
        props.fields.paymentMethod.value === "paypal" && _react2.default.createElement(_PayPalPaymentBox2.default, {
          error: props.paypalPaymentBoxError,
          paypalContainerId: props.paypalContainerId,
          paypalEmail: props.paypalEmail
        })
      ),
      _react2.default.createElement(_PaymentLogos2.default, {
        paymentLogosSrc: props.paymentLogosSrc,
        braintreeLink: props.braintreeLink
      })
    ),
    props.renderCaptcha(props.fields.captcha),
    _react2.default.createElement(
      "div",
      { className: footer },
      _react2.default.createElement(_Button2.default, {
        type: "submit",
        className: confirmButton,
        disabled: props.fields.paymentMethod.value === "paypal" && !props.paypalNonce || !!props.message,
        mode: "secondary",
        label: "Save Changes",
        loading: props.updating
      })
    )
  );
};

var AddressAndPaymentSettingForumContainer = function AddressAndPaymentSettingForumContainer(props) {
  return _react2.default.createElement(AddressAndPaymentSettingForum, {
    nextCharge: props.nextCharge,
    paypalContainerId: props.paypalContainerId,
    fields: props.fields,
    error: (0, _paymentErrorMessage2.default)(props._error),
    message: props.message,
    existingMethod: props.existingMethod,
    handleSubmit: props.handleSubmit,
    updating: props.updating,
    paypalIconSrc: "/icons/pay-with-paypal.png",
    paypalLoaded: false,
    paypalNonce: props.paypalNonce,
    paymentLogosSrc: props.paymentLogosSrc,
    braintreeLink: props.braintreeLink,
    onCancelSubscriptionClick: props.onCancelSubscriptionClick,
    renderCaptcha: props.renderCaptcha,
    paypalPaymentBoxError: props.paypalPaymentBoxError,
    lockCountryAndVat: false,
    validatingVat: props.asyncValidating === "vatNo",
    creditCardPrepare: props.creditCardPrepare,
    paypalEmail: props.paypalEmail,
    validatePostalCode: props.validatePostalCode,
    address: props.address
  });
};

exports.default = (0, _reduxForm.reduxForm)({
  fields: ["paymentMethod", "captcha", "name", "company", "address", "postalCode", "city", "country", "vatNo", "validatingField", "isVatValid", "isPromoCodeValid", "promoCode", "state", "address2", "mainDivision"],
  form: "checkout",
  validate: _paymentSettingsFormValidation.validateWithBilling,
  asyncValidate: _addressFormValidation.asyncValidate,
  asyncBlurFields: ["vatNo", "postalCode"]
})((0, _recompose.lifecycle)({
  componentDidMount: function componentDidMount() {
    this.props.validatePostalCode({ postalCode: "", countryCode: "" });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.fields.paymentMethod.value === "cc" && nextProps.fields.paymentMethod.value === "paypal") {
      if (this.props.onPayPalPrepare) {
        this.props.onPayPalPrepare();
      }
    }
    if (nextProps.fields.paymentMethod.value === "cc") {
      this.props.setCreditCardState();
    }

    if (this.props.fields.country.value !== nextProps.fields.country.value) {
      if (nextProps.fields.country.value === "US" || nextProps.fields.country.value === "CA") {
        this.props.validatePostalCode({
          postalCode: "",
          countryCode: nextProps.fields.country.value
        });
      }

      if (nextProps.fields.country.value === "IN") {
        var indiaStateList = (0, _countryStateCodes.getIndiaStates)();
        var indiaState = indiaStateList && indiaStateList.find(function (x) {
          return x !== undefined;
        });
        this.props.fields.state.onChange(indiaState.name);
        this.props.fields.mainDivision.onChange(indiaState.code);
      } else {
        this.props.fields.state.onChange("");
        this.props.fields.mainDivision.onChange("");
      }
      this.props.fields.city.onChange("");
      this.props.fields.postalCode.onChange("");
    }
    if (nextProps.address !== this.props.address) {
      var stateList = nextProps.address.stateList;

      var firstItem = stateList && stateList.find(function (x) {
        return x !== undefined;
      });
      if (firstItem) {
        this.props.fields.state.onChange(firstItem.name);
        this.props.fields.mainDivision.onChange(firstItem.code);
        var cities = firstItem.cities;

        var city = cities && cities.find(function (x) {
          return x !== undefined;
        });
        if (city) {
          this.props.fields.city.onChange(city);
        }
      } else {
        this.props.fields.state.onChange("");
      }
    }
  }
})(AddressAndPaymentSettingForumContainer));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentsAndSettingsPopup/AddressAndPaymentSettingForum.js
// module id = 2804
// module chunks = 0